module.exports = __webpack_public_path__ + "static/tm-juliaNewberry-51fad796195fed0d029dd8619aeb049a.png";